import { Fragment, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import Slider from "../modules/public/slider/slider";
import useSharedData from "./useSharedData";

const usePage = () => {
  const { pathname } = useLocation();
  const { page } = useSharedData();

  useEffect(() => {
    const title = page?.id ? page.title : "آواکس | پلتفرم آنلاین خدمات پستی";
    const metaDes = page?.id
      ? page.metaDescription
      : "آواکس | پلتفرم آنلاین خدمات پستی";

    document.title = title;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", metaDes);
    }
  }, [pathname]);

  const pageSliders =
    page?.img_slider?.length > 0 ? (
      <Slider images={page.img_slider} />
    ) : (
      <Fragment></Fragment>
    );

  const pageText = page?.descripthon ? (
    <Container className="page-text mt-4">
      <div dangerouslySetInnerHTML={{ __html: page.descripthon }} />
    </Container>
  ) : (
    <Fragment></Fragment>
  );

  const pageImage = page?.image ? (
    <Container className="text-center">
      <img src={page.image} className="w-50" alt="تصویر صفحه" />
    </Container>
  ) : (
    <Fragment></Fragment>
  );

  return { pageSliders, pageText, pageImage, pageBody: page?.body };
};

export default usePage;
